<h2 mat-dialog-title>{{ 'keyboardShortcuts' | translate }}</h2>
<mat-dialog-content>
  <dl class="shortcuts">
    @for (shortcut of shortcuts; track shortcut.action) {
      <dt>
        @for (key of shortcut.keys; track key) {
          <kbd>{{ key }}</kbd>
        }
      </dt>
      <dd>{{ shortcut.action | translate }}</dd>
    }
  </dl>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    mat-dialog-close
  >
    {{ 'close' | translate }}
  </button>
</mat-dialog-actions>
